export function orgPath({ locale = '', orgId = '', peId = '', c = false }) {
 let path = '';

 // check current locale,
 // if not set or en is set
 // then path will start from '/'
 // else '/<local>'
 if (locale != '' && locale != 'en') {
  path = path + `/${locale}`;
 }

 // if value of c is 1 then '/c' will be prefix in url after /lang,  ex '/es/c/...'
 if (c) {
  path = path + '/c';
 }
 path = path + `/${orgId}`;

 // if peid is set then /<peid> will be suffix of url
 if (peId != '') {
  path = path + `/${peId}`;
 }

 return path;
}
